module.exports = __webpack_public_path__ + "static/img/技能强国.8ca4b942.png";